import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import SwalServices from "../../services/swalServices/SwalServices.js";

class Statemaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.itemMasterServices = new ItemMasterServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      stateList: [],
      tableStatus: "",
      stateDetails: {
        stateName: "",
        stateCode: 0,
      },
    };
  }

  componentDidMount() {
    this.getAllStates();
  }

  getAllStates = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllStates().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState({ stateList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditStates = () => {
    if (this.state.stateDetails.stateName !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.stateDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditStates(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.resetForm();
            this.SwalServices.Success(response.Message);
            this.setState({ isLoading: false })
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.stateDetails;
    details.stateName = "";
    details.stateCode = 0;
    this.setState({ stateDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllStates();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.stateDetails;
    details[name] = value.toUpperCase();
    this.setState({ stateDetails: details });
  };

  getPackingMaterialById = (group) => {
    let details = this.state.stateDetails;
    details.stateName = group.stateName;
    details.stateCode = group.stateCode;
    this.setState({ stateDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteStateById = (id) => {
    this.itemMasterServices.deleteStateById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllStates();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category state-master-page">
        <div className="item-form">
          <div className="form-table w-[60%]">
            <div className="item-grp !flex !gap-2.5 !mb-3.5">
              <div className="input-grp !gap-0 w-[80%]">
                <label>State</label>
                <input
                  className="inputFocus"
                  type="text"
                  id="stateName"
                  name="stateName"
                  value={this.state.stateDetails.stateName}
                  onChange={(event) => this.handleChange(event, "stateName")}
                />
              </div>
              <div className="input-grp !gap-0 w-[20%]">
                <label>State Code</label>
                <input
                  className="inputFocus"
                  type="text"
                  id="stateCode"
                  name="stateCode"
                  value={this.state.stateDetails.stateCode}
                  onChange={(event) => this.handleChange(event, "stateCode")}
                />
              </div>
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditStates()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditStates()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[70%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '65%' }}>State Name</td>
                    <td style={{ width: '20%' }}>State Code</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.stateList &&
                    this.state.stateList.length > 0 ?
                    this.state.stateList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.stateName}</td>
                        <td>{group.stateCode}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getPackingMaterialById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteStateById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.stateList &&
                      this.state.stateList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.stateList &&
                      this.state.stateList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Statemaster;
